export default __webpack_public_path__ + "static/media/attisLogo.a4328a49.png";